// Copyright (c) Docugami, Inc. All rights reserved.

import { IChunkLinking, noOpChunkLinking } from "hooks/ChunkLinking"
import React, { useContext } from "react"

interface IReportDocumentViewContext {
    chunkLinkingState: IChunkLinking;
}

export const DocumentViewContext = React.createContext<IReportDocumentViewContext>({
    chunkLinkingState: noOpChunkLinking
});

export const useReportDocumentContext = () => useContext(DocumentViewContext);